export default __webpack_public_path__ + "static/media/FLNeutral.a3c91e32.svg";